import { jwtDecode } from 'jwt-decode';
import isNil from 'lodash.isnil';
import get from 'lodash.get';
import { SHARED_API_URL } from '../../../constants/shared/ApiConstants';
import MASClient from './MASClient';

class KeycloakClient {
    getToken = () => this.client.token;

    updateToken = () => this.client.updateToken();

    setKeycloak(keycloakClient) {
        this.client = keycloakClient;
    }

    getUserEmail = () => jwtDecode(this.getToken()).email;

    getUserName = () => jwtDecode(this.getToken()).name;

    getUserFirstName = () => jwtDecode(this.getToken()).given_name;

    getUserLastName = () => jwtDecode(this.getToken()).family_name;

    getSessionId = () => jwtDecode(this.getToken()).session_state;

    isMasUser = () => !isNil(get(jwtDecode(this.getToken()), 'mclassUserSid'));

    logout = async () => {
        try {
            if (this.client && this.isMasUser()) {
                await MASClient.fetchMASToken(this.getToken());
            }
        } finally {
            window.location = SHARED_API_URL().BASE_URLS.LOGOUT_URL;
        }
    };
}

export default new KeycloakClient();
